exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".login-container {\n  height: 106%;\n  background-color: white; }\n\n.login-page {\n  max-width: 350px;\n  margin: 0 auto;\n  text-align: center;\n  padding-top: 10vh; }\n  .login-page h1 {\n    font-weight: 200;\n    margin-top: 23px;\n    font-size: 21px;\n    color: #6283a6; }\n  .login-page .form-content {\n    padding: 40px 0;\n    width: 350px; }\n  .login-page #password-recovery {\n    margin-bottom: 2em; }\n    .login-page #password-recovery a {\n      color: rgba(0, 0, 0, 0.38); }\n  .login-page .error {\n    color: #e60000;\n    font-size: 12px;\n    text-align: left;\n    margin-top: -1rem; }\n\n.ver-row {\n  width: 25%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto; }\n\n.ver {\n  position: absolute;\n  bottom: 5rem;\n  right: 10rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/maxsheikhizadeh/Desktop/GEN/physician-portal/src/app/shared/components/login/login.component.scss
// module id = ../../../../../src/app/shared/components/login/login.component.scss
// module chunks = main